export const BuildActionNames = (module: string, actionList: string[]): { [key: string]: string } =>
  actionList.reduce(
    (acc, curr) => {
      acc[curr] = `${module}/${curr}`;
      return acc;
    },
    {} as { [key: string]: string },
  );

export const truncateDecimals = (value: number, digitCount = 2): string => {
  let result = value.toString();
  const decimals = result.split('.');
  if (decimals.length > 1) {
    const decimalPlaces = decimals[1].length;
    if (decimalPlaces > digitCount) {
      result = `${decimals[0]}.${decimals[1].substring(0, digitCount)}`;
    }
  }

  if (result.endsWith('.')) {
    result = result.slice(0, -1);
  }
  return result;
};

export const getScriptUrl = (content: string | null): string | null => {
  if (!content) {
    return null;
  }

  // eslint-disable-next-line no-useless-escape
  const attr = /data-script-assets="([\w-\/\.\:\?\=]+)"/.exec(content);
  return attr ? attr[1] || null : null;
};

const utils = {
  BuildActionNames,
  truncateDecimals,
  getScriptUrl,
};

export default utils;
